"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.editMenu = editMenu;
exports.get = get;
exports.getAll = getAll;
exports.getLevel = getLevel;

var _request = _interopRequireDefault(require("@/utils/request"));

// 获取所有的Role
function getAll() {
  return (0, _request.default)({
    url: 'api/roles/all',
    method: 'get'
  });
}

function add(data) {
  return (0, _request.default)({
    url: 'api/roles',
    method: 'post',
    data: data
  });
}

function get(id) {
  return (0, _request.default)({
    url: 'api/roles/' + id,
    method: 'get'
  });
}

function getLevel() {
  return (0, _request.default)({
    url: 'api/roles/level',
    method: 'get'
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/roles',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/roles',
    method: 'put',
    data: data
  });
}

function editMenu(data) {
  return (0, _request.default)({
    url: 'api/roles/menu',
    method: 'put',
    data: data
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del,
  get: get,
  editMenu: editMenu,
  getLevel: getLevel
};
exports.default = _default;